import Country from '../components/DetailCountry/Country';

function Details(props) {
    return (
        <div className='container'>
            <Country />
        </div>
    );
}

export default Details;
